// "Sette olmayan gerekli göstergeler" (TODO-KPI-08): katalogda eşlemesi var, sette yok →
// "Sete ekle" (addSetIndicator). Metrik başına tek satır (kodlar birleşik).
import { useState } from "react";
import type { KpiDisclosureRow } from "@mahir/shared";
import { groupNotInSet, KPI_TARGETS_COPY } from "../../../lib/kpi-targets-ui";
import { btnGhost } from "../kpi-form-styles";

const C = KPI_TARGETS_COPY.disclosure;

export function MissingFromSetList({
  rows,
  canAdd,
  onAdd,
}: {
  rows: KpiDisclosureRow[];
  canAdd: boolean;
  onAdd: (metricId: string) => Promise<void>;
}): JSX.Element {
  const [busy, setBusy] = useState<string | null>(null);
  const [done, setDone] = useState<Set<string>>(new Set());
  const groups = groupNotInSet(rows);
  if (groups.length === 0)
    return (
      <p className="text-sm p-4" style={{ color: "var(--color-text-3)" }}>
        {C.noneNotInSet}
      </p>
    );
  return (
    <ul className="divide-y" style={{ borderColor: "var(--color-border)" }}>
      {groups.map((g) => (
        <li
          key={g.metricId}
          className="flex items-center gap-3 px-3 py-2 text-sm"
          data-metric={g.metricId}
        >
          <div className="flex-1 min-w-0">
            <div style={{ color: "var(--color-text)" }}>
              {g.label}
              {g.unit ? <span style={{ color: "var(--color-text-3)" }}> · {g.unit}</span> : null}
            </div>
            <div className="text-xs" style={{ color: "var(--color-text-3)" }}>
              {g.parentLabel ? `${g.parentLabel} · ` : ""}
              {g.codes.join(", ")}
            </div>
          </div>
          {canAdd ? (
            <button
              type="button"
              style={{ ...btnGhost, minHeight: 34, padding: "6px 12px" }}
              disabled={busy !== null || done.has(g.metricId)}
              onClick={() => {
                setBusy(g.metricId);
                void onAdd(g.metricId)
                  .then(() => setDone((s) => new Set(s).add(g.metricId)))
                  .finally(() => setBusy(null));
              }}
            >
              {done.has(g.metricId) ? C.added : busy === g.metricId ? C.adding : C.addToSet}
            </button>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
